import { render, staticRenderFns } from "./inboundDetails.vue?vue&type=template&id=3780a9db&scoped=true&"
import script from "./inboundDetails.vue?vue&type=script&lang=js&"
export * from "./inboundDetails.vue?vue&type=script&lang=js&"
import style0 from "./inboundDetails.vue?vue&type=style&index=0&id=3780a9db&scoped=true&lang=css&"
import style1 from "./inboundDetails.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3780a9db",
  null
  
)

export default component.exports